var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_setup.shouldRender),expression:"shouldRender"}],key:_setup.itemId,ref:"itemRef",class:_setup.twMerge(
      'group relative flex cursor-default select-none items-center rounded-sm aria-selected:bg-gray-100 aria-selected:text-gray-900',
      _vm.twClass,
    ),attrs:{"role":"option","cmd-item":"","aria-selected":_setup.isSelected,"aria-disabled":!_setup.shouldRender,"data-value":_vm.value},on:{"click":_setup.onSelect,"mouseenter":_setup.select}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }